import dayjs from 'dayjs';
import { Language } from '../../../types/language';
import { PortSelectItem } from '../../../types/port';
import { Route, SimpleRoute } from '../../../types/route';
import { buildDayjsTimeCompatibleString } from '../../../utils/date';
import { ContractBadgeStatus, ProcessedRoute } from './types';
import { RouteStatus } from '../../../types/core';
import { MINIMUM_AMOUNT_OF_VESSELS_PER_OPERATOR } from '../../../types/vessel';

export const convertSimpleRouteToRoute = (
  simpleRoute: SimpleRoute,
  portsMap: Record<string, PortSelectItem>,
): Route => {
  const portOfArrival = portsMap[simpleRoute.portOfArrivalId].portInstance;
  const portOfDeparture = portsMap[simpleRoute.portOfDepartureId].portInstance;
  return {
    id: simpleRoute.id,
    dateFrom: simpleRoute.dateFrom,
    dateTo: simpleRoute.dateTo,
    departureTime: simpleRoute.departureTime,
    portOfDeparture: {
      id: simpleRoute.portOfDepartureId,
      names: portOfDeparture?.names ?? { en: '-', ga: '-' },
    },
    portOfArrival: {
      id: simpleRoute.portOfArrivalId,
      names: portOfArrival?.names ?? { en: '-', ga: '-' },
    },
    repeatedOnDays: simpleRoute.repeatOnDays,
    routeStatus: RouteStatus.Enabled,
  };
};

export const processRoute = (
  route: Route,
  language: Language,
  portsMap: Record<string, PortSelectItem>,
  todayString?: string,
): ProcessedRoute => {
  return {
    ...route,
    dateFrom: dayjs(route.dateFrom),
    dateTo: dayjs(route.dateTo),
    departureTime: dayjs(
      buildDayjsTimeCompatibleString(route.departureTime, todayString),
    ),
    portOfDeparture: portsMap[route.portOfDeparture.id] ?? {
      value: route.portOfDeparture.id,
      label: route.portOfDeparture.names[language],
      issue: 'unallowed',
    },
    portOfArrival: portsMap[route.portOfArrival.id] ?? {
      value: route.portOfArrival.id,
      label: route.portOfArrival.names[language],
      issue: 'unallowed',
    },
  };
};

export const getContractBadgeStatus = (
  isExpired: boolean,
  assignedVesselsCount: number,
  hasValidInsurance: boolean,
) =>
  isExpired
    ? ContractBadgeStatus.Expired
    : assignedVesselsCount < MINIMUM_AMOUNT_OF_VESSELS_PER_OPERATOR ||
        !hasValidInsurance
      ? ContractBadgeStatus.Uncompliant
      : ContractBadgeStatus.Compliant;
